import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  imports: [NgIf, MatButtonModule, MatIconModule],
  selector: 'app-empty-table-placeholder',
  template: `
    <div class="empty-table-message">
      <div>
        <mat-icon>announcement</mat-icon>
      </div>
      <div>{{ message }}</div>
      <div class="padding-button">
        <button *ngIf="showButton" mat-raised-button color="primary" (click)="handleButtonClick()">
          {{ buttonText }}
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./empty-table-placeholder.component.scss'],
})
export class EmptyTablePlaceholderComponent {
  @Input()
  message = 'There are no items to display';
  @Input()
  buttonText = 'click';
  @Input()
  showButton = false;

  @Output()
  opened: EventEmitter<null> = new EventEmitter();

  handleButtonClick(): void {
    this.opened.emit(null);
  }
}
